export {
  textSectionObsv,
  lottieAnimationObsv,
  mobileStickyAnimationObsv,
};

/**
 * Creates a new IntersectionObserver that will
 * Add animation classes to an element when it is in view.
 * @return {IntersectionObserver}     A new IntersectionObserver used to observe an element.
 */
function textSectionObsv() {
  return new IntersectionObserver((changes) => {
    changes.forEach(change => {
      // If the window height is too small, animations may not play.
      // To counter this, we check the screen height, and compare against the target's height (with 50px of padding to be safe)
      const windowTooShort = (change.rootBounds.height <= change.boundingClientRect.height + 50) && (change.intersectionRatio > 0);
      const isMobile = window.innerWidth < 1040 && change.intersectionRatio > 0;
      if (change.intersectionRatio >= 0.8 || windowTooShort || isMobile ) {
        change.target.classList.remove('ani__exit');
        change.target.classList.add('ani__enter');
      }
    });
  }, {
    threshold: [0, 0.2, 0.8, 1],
  });
}

/**
 * Creates a new IntersectionObserver that will
 * plays a Lottie animation ONLY ONCE when it enters the viewport
 * @param  {Object} lottieAnimation   This is a Lottie animation created using the lottie-web package.
 * @param  {Number} intersectionRatio How much of the animation needs to be on screen before it is played.
 * @return {IntersectionObserver}     A new IntersectionObserver used to observe an element.
 */
function lottieAnimationObsv(lottieAnimation, intersectionRatio = 0.5) {
  return new IntersectionObserver((changes) => {
    changes.forEach(change => {
      // If the window height is too small, animations may not play.
      // To counter this, we check the screen height, and compare against the target's height (with 50px of padding to be safe)
      const windowTooShort = (change.rootBounds.height <= change.boundingClientRect.height + 50) && (change.intersectionRatio > 0);
      if (change.intersectionRatio >= intersectionRatio || windowTooShort) {
        lottieAnimation.play();
      } else if (!change.isIntersecting) {
        lottieAnimation.pause();
      }
    });
  }, {
    threshold: [0, intersectionRatio, 1],
  });
}

function mobileStickyAnimationObsv(lottieAnimation, animationSegments, intersectionRatio = 0.8) {
  return new IntersectionObserver((changes) => {

    // TODO: destory the observer when the screen changes size,
    // rather than simply doing nothing when it is triggered.
    if (window.matchMedia('(min-width: 750px)').matches) return;

    changes.forEach(change => {
      if (change.intersectionRatio >= intersectionRatio) {
        const index = change.target.dataset.scrollamaIndex;
        const segment = animationSegments[parseInt(index)];
        lottieAnimation.playSegments(segment, true);
      }
    });
  }, {
    threshold: [0, intersectionRatio],
  });
}
